import {FC, ReactNode} from 'react'
import {Container} from 'react-bootstrap'
import NavigationHeader from '../navigation/NavigationHeader'
import BreadcrumbBar from '../navigation/BreadcrumbBar'
import AppPromoBanner from '../promo/AppPromoBanner'
import {usePendingSocietyJoin} from '../../hooks/usePendingSocietyJoin'
import {Footer} from './index.js'
import styles from './Layout.module.css'

interface LayoutProps {
  children: ReactNode;
  fullWidth?: boolean;
  showHeader?: boolean;
  flushTop?: boolean;
}

const Layout: FC<LayoutProps> = ({children, fullWidth = false, showHeader = true, flushTop = false}) => {
  usePendingSocietyJoin()

  return (
    <div className="min-vh-100 d-flex flex-column">
      <AppPromoBanner/>
      {showHeader && <NavigationHeader/>}
      <BreadcrumbBar fullWidth={fullWidth}/>

      <main className={`flex-grow-1 ${styles.main} ${flushTop ? styles.flushTop : ''}`}>
        {fullWidth ? children : <Container fluid="xl">{children}</Container>}
      </main>

      <Footer/>
    </div>
  )
}

export default Layout
